import { connect } from 'react-redux';
import AuctionsList from 'components/auctions/AuctionsList';
import {
  fetchLostAuctions,
  setAuctionsGridFilter,
  clearAuctionsGridFilter,
} from 'data/auctions/Auctions.actions';

import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      lang: state.i18n.locale,
      filters: state.auctions.filters,
      fetchingAuctions: state.auctions.fetchingLostAuctions,
      auctions: state.auctions.lostAuctions || [],
      user: state.app.user,
      lost: true,
    },
    state,
    'fuelTypes',
    'vehicleTypes',
    'gearBoxes',
    'wheelDrives',
    'partTypes',
    'regions',
    'partyTypes',
    'insurances',
    'bidFileTypes',
    'imitationPartCategories',
    'usedConditionTypes',
    'cancellationReasons',
    'applications',
    'memberships'
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setFilter: (name, value) => dispatch(setAuctionsGridFilter(name, value)),
    clearFilters: () => dispatch(clearAuctionsGridFilter()),
    fetchAuctions: skipStep => dispatch(fetchLostAuctions(skipStep)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuctionsList);
